import useAiIntegrationsTabs from './useAiIntegrationsTabs';
import RouterTabs from 'components/RouterTabs';

const AiIntegrationsSetting = () => {
  const tabs = useAiIntegrationsTabs();

  return (
    <div className='mt-4'>
      <RouterTabs tabs={tabs} withTabs={tabs.length > 1} buzzTabs />
    </div>
  );
};

export default AiIntegrationsSetting;
